import { useState } from "react";
import { Link, useLocation } from "react-router";
import { LogIn, Menu } from "lucide-react";
import { useSession } from "@/lib/store/session";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";
import { Brand } from "./Brand";
import { NavList } from "./NavList";
import { SyncChip } from "./SyncChip";
import { ThemeToggle } from "./ThemeToggle";
import { UserMenu } from "./UserMenu";
import { pageTitleFor, primaryNav, secondaryNav } from "./nav";

export function TopBar() {
  const { pathname } = useLocation();
  const loggedIn = useSession((s) => !!s.userId);
  const [open, setOpen] = useState(false);
  const title = pageTitleFor(pathname);
  const primary = loggedIn ? primaryNav : primaryNav.filter((i) => i.public);
  const secondary = loggedIn ? secondaryNav : secondaryNav.filter((i) => i.public);

  return (
    <header className="sticky top-0 z-20 border-b border-border bg-surface/90 pt-safe-top backdrop-blur supports-[backdrop-filter]:bg-surface/75">
      <div className="flex h-14 items-center gap-2 px-3 tab:h-16 tab:px-6">
        <Sheet open={open} onOpenChange={setOpen}>
          <Button variant="ghost" size="icon" className="tab:hidden" aria-label="Open menu" onClick={() => setOpen(true)}>
            <Menu />
          </Button>
          <SheetContent side="left" className="gap-3 p-4">
            <SheetTitle className="sr-only">Navigation</SheetTitle>
            <Brand to={loggedIn ? "/home" : "/auth"} className="mb-2" />
            <nav aria-label="Main" className="flex flex-col gap-3">
              <NavList items={primary} onNavigate={() => setOpen(false)} />
              <Separator />
              <NavList items={secondary} onNavigate={() => setOpen(false)} />
            </nav>
            {!loggedIn && (
              <Button asChild className="mt-2">
                <Link to="/auth" onClick={() => setOpen(false)}>
                  <LogIn /> Sign in
                </Link>
              </Button>
            )}
          </SheetContent>
        </Sheet>

        <h1 className="min-w-0 flex-1 truncate font-display text-base font-semibold tracking-tight tab:text-lg">{title}</h1>

        <div className="flex items-center gap-1.5">
          <SyncChip />
          <ThemeToggle />
          {loggedIn ? (
            <UserMenu />
          ) : (
            <Button asChild size="sm" className="hidden tab:inline-flex">
              <Link to="/auth">Sign in</Link>
            </Button>
          )}
        </div>
      </div>
    </header>
  );
}
